import { signupApi, userService } from '@saucelabs/sl-util-axios';

export const getCordToken = () => (
  signupApi.get('/api/cord-token')
);

export const getUserAttributes = () => (
  signupApi.get('/api/user-attributes')
);

export const switchActiveTeam = (payload) => (
  userService.put('/v1/users/me/active-team', payload)
);
